import type { Song, StudioActionJob } from '../types/domain';
import { ApiError } from './errors';
import { http } from './http';

export const STUDIO_ACTION_POLL_INTERVAL_MS = 1_000;
export const MAX_STUDIO_ACTION_POLLS = 600;

export type StudioActionResult =
  | Song
  | { song: Song; firstSong: Song; secondSong: Song }
  | null;

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function waitForStudioAction<T = StudioActionResult>(
  songId: string,
  accepted: StudioActionJob
): Promise<T> {
  const job = await waitForStudioJob(songId, accepted);
  if (job.result === undefined) {
    throw new ApiError(500, 'Studio completed without a result.', 'server_error');
  }
  return job.result as T;
}

export async function waitForStudioJob(
  songId: string,
  accepted: StudioActionJob
): Promise<StudioActionJob> {
  let job = accepted;
  for (let poll = 0; poll < MAX_STUDIO_ACTION_POLLS; poll += 1) {
    if (job.status === 'succeeded') {
      return job;
    }
    if (job.status === 'failed') {
      throw new ApiError(422, job.error ?? 'Studio processing failed.', 'validation_failed');
    }
    await sleep(STUDIO_ACTION_POLL_INTERVAL_MS);
    job = await http.get<StudioActionJob>(`/songs/${songId}/studio/jobs/${job.id}`);
  }
  throw new ApiError(504, 'Studio processing is still running. Please try again.', 'server_error');
}
